import { Stack, Image, ImageFit } from '@fluentui/react';
import React, { useContext, useEffect, useState } from 'react';
import { TProduct, TSet, TShoppingCart } from '../constants/types';
import { NavLink } from 'react-router-dom';
import styles from '../styles/collectie.module.scss';
import CarouselComponent from './carouselComponent';
import MainCarouselComponent, { TCarouselItem } from './mainCarouselComponent';
import GlobalContext from '../_contexts/GlobalContext';
import Footer from './footerComponent';
import ProductListItem from './Product/productListItemComponent';
import CountTag from './countTag';

export interface IWelcomeComponentProps {
    UpdateStateExtern: Function;
    onSetSelectedSet: Function;
    ShowAlertCoachmarks: Function;
    Sets: TSet[];
    DoSearch: Function;
    shoppingkart: TShoppingCart;
    onBuyClick: Function;
    SetSelectedProductForAlert: Function;
}

const WelcomeComponent : React.FunctionComponent<IWelcomeComponentProps> = (props : IWelcomeComponentProps) => {
    const [products, setproducts] = useState<TProduct[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [sets, setsets] = useState<TSet[]>(props.Sets);
    const [maxIndex, setmaxIndex] = useState<number>(24);
    const [carouselItems, setcarouselItems] = useState<TCarouselItem[]>([]);
    const [shimmerEnabled, setShimmerEnabled] = useState<boolean>(true);

    const { DebugEnabled, BGCOLOR, PageWidth, MainCarouselSets, DevEnabled, AnimationsEnabled, ShowFooter, SetShowFooter, GlobalImagesVersion, SHOW_PROMOTED_MIN_WIDTH, SET_COLOR, SHOWSETCOUNTTAG, SETCOUNTTAGLOCATION } = useContext(GlobalContext);

    useEffect(() => {
        setsets(props.Sets);
        setcarouselItems(getCarouselItems(props.Sets));
    },[props.Sets])

    useEffect(() => {
        GetPromotedProducts();
        
        window.onscroll = onScroll;

        //Unmount code
        return () => {
            window.onscroll = null;
        }
    },[]);

    useEffect(() => {
        window.onscroll = onScroll;
    }, [maxIndex]);

    useEffect(() => {
        setcarouselItems(getCarouselItems(sets));
    },[PageWidth]);

    const getCarouselItems = (_sets: TSet[] = []) : TCarouselItem[] => {
        let carouselitems : TCarouselItem[] = [];
        let csets : TSet[] = [];
        MainCarouselSets?.forEach((setid:number) => {
            csets = csets.concat(_sets.filter(s => s.id === setid));
        });

        csets.forEach(set => {
            carouselitems.push({
                quickLinkImageUrl: process.env.PUBLIC_URL + `/assets/products/${set.id.toString()}/${set.id}.webp`,
                quickLinkOnClick: () => { onSetSelectedSet(set.id); },
                content: <div onClick={() => { onSetSelectedSet(set.id); }} style={{cursor:"pointer"}}>                                                               
                            <div style={{width:PageWidth, backgroundImage:`url(${process.env.PUBLIC_URL}/assets/products/${set.id.toString()}/logo.webp?v=${GlobalImagesVersion})`}} className={styles.mainSelectedSetLogo} /> 
                         </div>
                         
            });
        });
        return carouselitems;
    }

    const onScroll = () => {
        if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight - 100) {
            setmaxIndex(maxIndex + 6);
        }
        if (maxIndex >= sets.length) {
            SetShowFooter(true);
            window.onscroll = null;
        }
    }

    const onSetSelectedSet = (setId:number) => {
        props.UpdateStateExtern(["firstLoad","showFooter"],[false,true]).then(() => {
            props.onSetSelectedSet(setId);
        }).catch(err => {});
    }

    const GetPromotedProducts = async () => {
        return new Promise((resolve,reject) => {
            let hostUrl = `${window.location.origin}/Backend`
            if (DevEnabled) {
                hostUrl = process.env.REACT_APP_DEV_API_URL;
            }
            
            fetch(`${hostUrl}/GetPromotedProducts?max=10`, {
                method: 'GET',
            }).then((response) => response.json()).then((data: TProduct[]) => {
                data.forEach(product=> {
                    product.set = sets.filter(set => set.id === product.setID)[0];
                    product.priceInUSD = Math.round(product.priceInUSD * 100) /100;
                    product.scost = `${product.cost}`;
                    let imageUrls: string[] = [];
                    product.imageNames?.split(',').forEach(imageName => {
                        imageUrls.push(`${process.env.PUBLIC_URL}/assets/products/${product.setID}/${product.id.toString()}/${imageName}?v=${GlobalImagesVersion}`);
                    });
                    product.imageUrls = imageUrls;
                });
                setproducts(data);
                setLoading(false);
            }).catch(err => {
                console.log(err);
            });
        });
    }

    function onMouseOver() {
        setShimmerEnabled(false);
        setTimeout(() => {
            setShimmerEnabled(false);
        }, 300);
    }

    function onMouseLeave() {
        setTimeout(() => {
            setShimmerEnabled(true);
        }, 300);
    }

    return (
        <div>
            {DebugEnabled && <div>Outer: {window.outerWidth} - {window.outerHeight} Inner: {window.innerWidth} - {window.innerHeight}</div>}
            <div className={styles.mainSection} style={{backgroundColor:BGCOLOR}}>
                <Stack horizontalAlign='center'>
                    <div style={{maxWidth: PageWidth, overflow:"hidden"}}>
                        {carouselItems.length && <MainCarouselComponent isDev={DevEnabled} switchSpeed={20} animationsEnabled={AnimationsEnabled} items={carouselItems} maxWidth={PageWidth} />}
                        <div style={{maxWidth: PageWidth-10, overflow:"hidden"}}>
                            <CarouselComponent animationsEnabled={false} isDev={DevEnabled} />
                        </div>
                    </div>
                    {window.innerWidth >= SHOW_PROMOTED_MIN_WIDTH && <Stack horizontal style={{maxWidth:"100%",marginBottom:8}}>
                        {products.map((product,index) => {
                            if ((PageWidth > 960 && (220*(1+index) < PageWidth)) || 
                                (PageWidth <= 960 && (180*(index+1) < PageWidth))){
                                const r = Math.floor(Math.random() * 8);
                                let shimmerStyle = styles[`productshimmer${r}`];
                                if (loading) {
                                    shimmerStyle = styles.productshimmerLoading;
                                }
                                return <ProductListItem hideSwipe={true}
                                                        AlertCoachmarkVisible={false}
                                                        animationsEnabled={false}
                                                        product={product}
                                                        shoppingkart={props.shoppingkart}
                                                        onBuyClick={props.onBuyClick}
                                                        SetSelectedProductForAlert={props.SetSelectedProductForAlert} />                                        
                            }
                        })}
                    </Stack>}
                    <Stack horizontalAlign='center' style={{maxWidth: PageWidth, width:"100%", paddingLeft:7}}>
                        <div className={styles.setLogoMenuContainer}>
                            {sets.map((set,index) => {
                                if (index < maxIndex && !set.isParent) {
                                    return  <NavLink to={`/set/${set.name}`} className={styles.setLogoMenuWelcomeContainer} onClick={() => { onSetSelectedSet(set.id); }}>
                                                {SHOWSETCOUNTTAG === true ? 
                                                    <CountTag count={set.productcount} left={SETCOUNTTAGLOCATION[0] === "L" ? true : false} bottom={SETCOUNTTAGLOCATION[1] === "B" ? true : false} children={
                                                        <div className={styles.setLogoWelcomeImageContainer} style={{backgroundColor:SET_COLOR}}>
                                                            <Image style={{ maxWidth:(PageWidth/3)-24,
                                                                            minWidth:(PageWidth/3)-24,
                                                                            minHeight:(PageWidth/4),
                                                                            maxHeight:(PageWidth/4),
                                                                            backgroundImage:`url('${process.env.PUBLIC_URL}/assets/container_set_bg.webp?v=${GlobalImagesVersion}')`,
                                                                            width:"100%"}} 
                                                                            className={`${styles.cPanel} ${styles.setLogoMenuWelcome}`} src={process.env.PUBLIC_URL + `/assets/products/${set.id.toString()}/${set.id.toString()}.webp`} 
                                                                            alt={set.name} />    
                                                        </div>}
                                                    /> : 
                                                    <div className={styles.setLogoWelcomeImageContainer} style={{backgroundColor:SET_COLOR}}>
                                                        <Image style={{ maxWidth:(PageWidth/3)-24,
                                                                        minWidth:(PageWidth/3)-24,
                                                                        minHeight:(PageWidth/4),
                                                                        maxHeight:(PageWidth/4),
                                                                        backgroundImage:`url('${process.env.PUBLIC_URL}/assets/container_set_bg.webp?v=${GlobalImagesVersion}')`,
                                                                        width:"100%"}} 
                                                                        className={`${styles.cPanel} ${styles.setLogoMenuWelcome}`} src={process.env.PUBLIC_URL + `/assets/products/${set.id.toString()}/${set.id.toString()}.webp`} 
                                                                        alt={set.name} />    
                                                    </div>
                                                }
                                            </NavLink>
                                    }
                                }
                            )}
                        </div>
                    </Stack>
                    {ShowFooter ? <Footer UpdateStateExtern={props.UpdateStateExtern} /> : <div>Meer sets aan het laden...</div>}
                </Stack>
            </div>
        </div>
    );
}

export default WelcomeComponent;